var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"purchase-failure"},[_c('div',{staticClass:"message-container"},[_c('img',{staticClass:"failure-icon",attrs:{"src":require("../../../../assets/failure.png"),"alt":"Failure Icon"}}),_c('p',{staticClass:"failure-message"},[_vm._v("Lo sentimos. Su compra no pudo ser confirmada, por favor refresque la página o comuníquese con nosotros.")])])])
}]

export { render, staticRenderFns }